import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReportesRoutingModule } from './reportes-routing.module';
import { ReportsIndexComponent } from './reports-index/reports-index.component';
import { StockIndexComponent } from './stock/stock-index/stock-index.component';
import { StockActualComponent } from './stock/stock-actual/stock-actual.component';
import { SharedModule } from '@shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConsolidadoComponent } from './informes/consolidado/consolidado.component';
import { ConsolidadoListaComponent } from './informes/consolidado/consolidado-lista/consolidado-lista.component';
import { ConsolidadoDetalleComponent } from './informes/consolidado/consolidado-detalle/consolidado-detalle.component';
import { InformesIndexComponent } from './informes/informes-index/informes-index.component';
import { ResolucionMensualComponent } from './informes/resolucion-mensual/resolucion-mensual.component';
import { ModalGenerarResolucionComponent } from './informes/resolucion-mensual/modal-generar-resolucion/modal-generar-resolucion.component';
import { VisorInformeResolucionComponent } from './informes/resolucion-mensual/visor-informe-resolucion/visor-informe-resolucion.component';
import { ModalJustificacionResolucionComponent } from './informes/resolucion-mensual/modal-justificacion-resolucion/modal-justificacion-resolucion.component';
import { ReporteMovimientosComponent } from './informes/reporte-movimientos/reporte-movimientos.component';
import { ReporteAnulacionAerovalesComponent } from './informes/reporte-anulacion-aerovales/reporte-anulacion-aerovales.component';
import { VisorComentariosAnulacionComponent } from './informes/reporte-anulacion-aerovales/visor-comentarios-anulacion/visor-comentarios-anulacion.component';
import { InterfacesDetalleComponent } from './interfaces/interfaces-detalle/interfaces-detalle.component';
import { InterfacesListaComponent } from './interfaces/interfaces-lista/interfaces-lista.component';
import { InterfacesIndexComponent } from './interfaces/interfaces-index/interfaces-index.component';
import { InterfaceClientesComponent } from './interfaces/interfaz-clientes/interfaz-clientes.component';
import { InterfaceDocumentosComercialesComponent } from './interfaces/interfaz-documentos-comerciales/interfaz-documentos-comerciales.component';
import { InterfaceSapComponent } from './interfaces/interfaz-sap/interfaz-sap.component';
import { InterfaceStockComponent } from './interfaces/interfaz-stock/interfaz-stock.component';
import { LegajosIndexComponent } from './legajos/legajos-index/legajos-index.component';
import { LegajosAerovalesFacturasComponent } from './legajos/legajos-aerovales-facturas/legajos-aerovales-facturas.component';
import { LegajosAuditoriasComponent } from './legajos/legajos-auditorias/legajos-auditorias.component';
import { DespachoModule } from '@despacho/despacho.module';

@NgModule({
  declarations: [
    ReportsIndexComponent,
    StockIndexComponent,
    StockActualComponent,
    ConsolidadoComponent,
    ConsolidadoListaComponent,
    ConsolidadoDetalleComponent,
    InformesIndexComponent,
    ResolucionMensualComponent,
    ModalGenerarResolucionComponent,
    VisorInformeResolucionComponent,
    ModalJustificacionResolucionComponent,
    ReporteMovimientosComponent,
    ModalJustificacionResolucionComponent,
    ReporteAnulacionAerovalesComponent,
    VisorComentariosAnulacionComponent,
    InterfacesDetalleComponent,
    InterfacesListaComponent,
    InterfacesIndexComponent,
    InterfaceClientesComponent,
    InterfaceDocumentosComercialesComponent,
    InterfaceSapComponent,
    InterfaceStockComponent,
    LegajosIndexComponent,
    LegajosAerovalesFacturasComponent,
    LegajosAuditoriasComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ReportesRoutingModule,
    NgbModule,
    FormsModule,
    SharedModule,
    DespachoModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ReportesModule { }
